import axios from "axios";
import { WEB_URL } from "../../constants";

export const FgtUsernameApi = async (body, ApiStatus) => {
    ApiStatus({ isLoader: true, isError: false, data: null });
    try {
        let res = await axios.post(WEB_URL + "forgot_username", body);
        ApiStatus({ isLoader: false, isError: false, data: res.data });
    } catch (err) {
        ApiStatus({ isLoader: false, isError: true, data: null });
    }
}